import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlayCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12" />
    <path d="m21.54 15.18-8-5A1 1 0 0 0 13 10a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1 1 1 0 0 0 .53-.15l8-5a1 1 0 0 0 .01-1.67m-7.54 4v-6.36L19.08 16Z" />
  </svg>
);
const ForwardRef = forwardRef(IconPlayCircleOutlineSVG);
ForwardRef.displayName = "IconPlayCircleOutline";
export { ForwardRef as IconPlayCircleOutline };
